export default __webpack_public_path__ + "static/media/77.dac2a108.jpg";